// Phase G3 Stage 3: /parent/tree — SkillTree.
import { createFileRoute } from "@tanstack/react-router";
import { SkillTree } from "@/screens/SkillTree";
export const Route = createFileRoute("/parent/tree")({ component: SkillTree });
